import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import {
    FiDocumentTemplateBasicStructures,
    IDocumentTemplateBasicStructure,
} from '@fi-app/document-template/document-template-basic-structures';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { FiDialogConfirmDeleteComponent } from '@fi-shared/fi-dialogs-generic/confirm-delete/dialog-confirm-delete.component';
import { IDialogConfirmDeleteData } from '@fi-shared/fi-dialogs-generic/confirm-delete/dialog-confirm-delete-data';
import { AppTextService } from '@fi-shared/app-text';
import { ICommonDialogResult } from '@fi-shared/models/common';
import { TemplateModel } from '@fi-app/template/template.model';
import { getObjectTypeNameTextId } from '@fi-shared/utils';
import { ObjectTypes } from '@fi-shared/types';

@Component({
    selector: 'fi-document-template-edit-basic',
    templateUrl: './document-template-edit-basic.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./document-template-edit-basic.component.scss'],
    host: { class: 'fi-document-template-edit-basic' },
    standalone: false,
})
export class FiDocumentTemplateEditBasicComponent {
    @Input() selectedStructure: IDocumentTemplateBasicStructure;
    @Output() selectedStructureChange = new EventEmitter<IDocumentTemplateBasicStructure>();
    @Input() template: TemplateModel;

    constructor(
        private fiDialogsService: FiDialogsService,
        private appTextService: AppTextService,
    ) {}

    BasicStructures = FiDocumentTemplateBasicStructures;

    basicStructureClick(structure: IDocumentTemplateBasicStructure) {
        this.changeBaseStructureConfirm().then((result) => {
            if (result.result) {
                this.selectedStructure = structure;
                this.selectedStructureChange.emit(structure);
            }
        });
    }

    private changeBaseStructureConfirm(): Promise<ICommonDialogResult> {
        const documentsCount = this.template.DocumentIds.length;
        const confirmTextToInput = this.appTextService.get('common.confirm').toUpperCase();
        const itemName = this.appTextService
            .get(getObjectTypeNameTextId(ObjectTypes.Document, documentsCount !== 1))
            .toLowerCase();
        const message = this.appTextService.get('template.change_basic_structure_confirm', {
            '{confirm_text}': confirmTextToInput,
            '{count}': documentsCount,
            '{item_name}': itemName,
        });
        const promise = new Promise<ICommonDialogResult>((resolve, reject) => {
            if (!this.template.DocumentIds.length) {
                resolve({ result: true });
                return;
            }
            const dialogContentData: IDialogConfirmDeleteData = {
                step1: {
                    message: message,
                    buttonText: this.appTextService.get('common.confirm'),
                    confirmTextToInput: confirmTextToInput,
                },
            };

            this.fiDialogsService
                .custom({
                    headerText: this.appTextService.get('common.warning'),
                    contentComponentRef: FiDialogConfirmDeleteComponent,
                    contentComponentData: dialogContentData,
                    config: {
                        maxWidth: '400px',
                    },
                })
                .onYesButtonClick(() => {
                    resolve({ result: true });
                })
                .onNoButtonClick(() => {
                    resolve({ result: false });
                });
        });

        return promise;
    }
}
